export enum DonationStatus {
  Initial,
  Active,
  Inactive,
}
